<template>
<div class="main">
	<Steps :index="0" product-name="平安企业团体雇主责任保险" />
	<Applicant :info="info.companyVO" @on-change="setApplicantData" ref="applicant" title="投保企业信息"/>
	<Recognize ref="recognize" :info="info" @set-amount="setAmount"/>
	<Invoice :info="info.invoice" ref="invoice" class="mt20"/>
	<div class="mt20 center">
       <!--  <p>投保时间：1年</p>
        <p>投保方案：</p> -->
        <p>总费用：<span class="price">{{amount}}元</span></p>
        <p class="mt10">
            <Button type="primary" @click="sub" :loading="loading">立即投保</Button>
        </p>
    </div>
	<TrackNotice v-if="id&&isRenew" />
</div>
</template>
<script>
import Steps from '../common/Steps'
import Recognize from './Recognize'
import Applicant from './common/Applicant'
import Invoice from './common/Invoice'
import { mapState } from 'vuex'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{ Steps,Recognize,Applicant,Invoice,TrackNotice },
	data () {
		return {
			info:{
				recognize:{
					insuredPeriod:'12',
					subjoinAllDay:false,
					subjoinOwnMedicine:false,
					subjoinProportionAdj:false
				},
				companyVO:{},
				invoice:{
					invoiceType:'1',
				},
				productCode:this.$route.query.productCode||'QYTTGZZRXPCNEW',
			},
			amount:'',
			loading:false,
			id:this.$route.params.id,
			isRenew:this.$route.query.renew||'',
		}
	},
	computed:{
		...mapState({
			userInfo:state=>state.common.info
		})
	},
	watch:{
		userInfo(){
			this.checkLogin()
		}
	},
	created () {
		if(this.checkLogin&&this.id){
			this.getInfo()
		}
		//获取单点登录信息
		this.getSsoInfo()
	},
	mounted(){
		// 重新投保
		// if(this.id&&this.isRenew){
		// 	this.track_is_new = true;
		// 	this.$nextTick(()=>{
		// 		this.trackInit();
		// 	})
		// } else {
		// 	// 回溯 开始录制
		// 	this.$nextTick(this.startRecord);
		// }
	},
	methods:{
		//获取单点登录信息
		getSsoInfo () {
			this.$axios.post("/employerLiability/getFlexibleEmpPlat").then(res=>{
				if(res){
					this.info.companyVO = {
						...res,
						organizationCode:res.unifiedSocialCreditCode
					}
				}
			})
		},
		checkLogin(){
			// 检测登录
			if(!this.userInfo.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		// 根据id获取信息
		getInfo(){
			this.$axios.post('/employerLiability/getDetailInfo.json',{
				policyId:this.id
			}).then(async res=>{
				res.list=res.list||[]
				let item=res.list&&res.list.length>0?res.list[0]:{};
				if(this.isRenew){
					// 续保
					let effectiveDateStart=this.formatDate(Date.parse(item.effectiveDateEnd)+3600*1000*24)
					let effectiveDateEnd=await this.$refs.recognize.getEffectiveDateEnd(effectiveDateStart,res.insuredPeriod)
					this.$refs.recognize.setStartTimeOption(effectiveDateStart)
					item.effectiveDateStart=effectiveDateStart;
					item.effectiveDateEnd=effectiveDateEnd;
				}
				let personList=res.list.map(item=>{
					return {
						msg:'校验通过',
						success:true,
						workType:item.jobTypeName,
						insurancePlan:item.insuranceSchemeName,
						name:item.insurantName,
						certificateNumber:item.insurantCertificateNumber,
						subjoinAllDay:item.subjoinAllDay,
						subjoinOwnMedicine:item.subjoinOwnMedicine,
						subjoinProportionAdj:item.subjoinProportionAdj
					}
				})
				this.info={
					...this.info,
					companyVO:{
						companyName:res.companyName,
						organizationCode:res.organizationCode,
						address:res.address,
						contactsName:res.contactsName,
						contactsPhone:res.contactsPhone,
						contactsEmail:res.contactsEmail,
						contactsCertificateNumber:res.contactsCertificateNumber,
						businessLicenseUrl:res.businessLicenseUrl,
						provinceCode:res.provinceCode,
						provinceName:res.provinceName,
						cityCode:res.cityCode,
						cityName:res.cityName,
						areaCode:res.areaCode,
						areaName:res.areaName,
					},
					recognize:{
						insuredPeriod:res.insuredPeriod+'',
						subjoinAllDay:item.subjoinAllDay||false,
						subjoinOwnMedicine:item.subjoinOwnMedicine||false,
						subjoinProportionAdj:item.subjoinProportionAdj||false,
						effectiveDateStart:item.effectiveDateStart||'',
						effectiveDateEnd:item.effectiveDateEnd||''
					},
					invoice:{
						invoiceType:res.invoiceType+'',
						invoiceName:res.invoiceName,
						invoiceFaxNo:res.invoiceFaxNo,
						invoiceAddress:res.invoiceAddress,
						invoicePhone:res.invoicePhone,
						invoiceBank:res.invoiceBank,
						invoiceAccount:res.invoiceAccount,
						email:res.email,
						postAddress:res.postAddress
					},
					personList:personList
				}
			});
			
		},
		// 校验
		async sub () {
			let applicant = await this.$refs.applicant.val();
			let recognize = await this.$refs.recognize.val();
			let invoice = await this.$refs.invoice.val();
			if(!applicant){
			    this.toast('投保企业信息校验失败','error');
			    return;
			}
			if(!recognize){
				return;
			}
			if(!invoice){
			    this.toast('发票信息校验失败','error');
			    return;
			}

			this.loading = true;
			recognize.employerTotalAmountVO.productCode = this.info.productCode
		    this.$axios.post('/employerLiability/buyingInsurance.json.all',{
				companyVO:{
					...applicant,
					...invoice
				},
				employerTotalAmountVO:recognize.employerTotalAmountVO,
				importEmployeeVOS:recognize.importEmployeeVOS,
				invoiceType:invoice.invoiceType,
			}).then(async res=>{
				this.loading = false;
				if(res.code==10000000){
					// // 回溯 停止录制
					// await this.stopRecord({
					// 	session_key:sessionStorage.track_session_key,
					// 	policy_id:res.data||''
					// });
					if(!this.id||res.data!=this.id){
						this.$router.replace(`/company-group-employer/fillin/${res.data}?productCode=${this.info.productCode}`)
					}
					this.$router.push('/company-group-employer/confirm/'+res.data);
				}else{
		            this.alert(res.msg)
		        }
			});
		},
		// 设置总费用
		setAmount(amount) {
			this.amount=amount;
		},
		// 同步投保公司数据，用于更新公司名称和社会代码，开票组件会用到
		setApplicantData(form) {
			this.$set(this.info,'invoice',{
				...this.info.invoice,
				...form
			})
		}
	}
}
</script>
<style scoped>
	.main{
		margin-top: 15px;
		padding :30px 40px;
	}
	.mt20{
	    font-size: 25px;
	    line-height: 1.8;
	}
	span.price{
	    color:#FF0000;
	    font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployer/Fillin.vue